import { render } from "./CookiesTable.vue?vue&type=template&id=1e7dcc49&scoped=true&ts=true"
import script from "./CookiesTable.vue?vue&type=script&lang=ts"
export * from "./CookiesTable.vue?vue&type=script&lang=ts"

import "./CookiesTable.vue?vue&type=style&index=0&id=1e7dcc49&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7dcc49"]])

export default __exports__